import {combineReducers} from 'redux';
import jwRouterReducer from './AboutJingWei/jwRouteReducer';
import heareMenuRoutePathReducer from './header/headerMenuReducer';
import homeReducer from './home/homeReducer';
import aboutPolicyReducer from './aboutPolicy/aboutPolicyReducer';
import jwRecruitmentReducer from './recruitment/jwRecruitmentReducer';
import bussinessReducer from './bussiness/bussinessReducer';
import contactUsReducer from './contactUs/contactUsReducer';
import footerFirmInfoReducer from './footer/footerFirmInfoReducer';
import jwListReducer from './AboutJingWei/jwListReducer';

const rootReducers=combineReducers({
    jwRouterReducer,
    heareMenuRoutePathReducer,
    homeReducer,
    aboutPolicyReducer,
    jwRecruitmentReducer,
    bussinessReducer,
    contactUsReducer,
    footerFirmInfoReducer,
    jwListReducer,
});

export default rootReducers;
